import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import { CusFormInput, CusFormLabel, FormSubTitleDesp, FormSubTitleTooltip, FormTitle, FormUpperCaseInput } from '../validation/Form-Components';
import bizBankingData from '../data/bizbankingservicedata.json'
import { nameOnCardValidator, nametoAppearValidator, suffixValidator } from '../validation/Validators';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import TooltipTemplate from '../components/TooltipTemplate';
import { Tooltip } from '@progress/kendo-react-tooltip';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import {Input} from '@progress/kendo-react-inputs';
import service from '../services/ApiService.js';
import sgdaccount from '../data/sgdaccount.json'
import mandates from '../data/mandate.json';
import frngaccount from '../data/foreignaccount.json';
import services from '../data/serviceslinkage.json'
import Loading from '../components/Loading';
import CardImg from '../images/PlatinumCard1.png';
import CusToast from '../components/CusToast';
import helper from '../factory/Helper';


const BizBankingService = (props) => {

    let timer;
    const detailsType='4';
    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 50 };
    const [dcApplicanCbo, setDCApplicanCbo] = useState({value:'',label:''});
    const [condOfSign, setCondOfSign] = useState({});
    const [showBizReg,setShowBizReg] = useState(true);
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [bizNameOnCard,setBizNameOnCard] = useState();
    const [nameOnCard,setNameOnCard] = useState();
    const [selectedApplyCheqBook,setSelectedApplyCheqBook] = useState();

    let applicant = {};
   const initResState = {
    CompDtls:{
        RegNo:'',
        CompName:''
    },
    BizAccts:{
        PrefSGDAcct:'',
        PrefFrngAcct:''
    },
    MaybankBussinessPlatinumCard:{
        CompanyNametoAppear: '',
        Applicant:{
            NRIC: '',
            NametoAppear:'',
        }
    },
    BizInternetBank:{
        ApprovalMandate:mandates[0].value,  //default 1 Approval
        AcctLinkList:{
            AcctLinkage:[]
        },
        ServiceLinkList: {
            ServiceLinkage: [],
            Suffix:''
        },
        UserRegistration:{
            AuthUser:[{
                NRIC:'',
                Seq:''  
            }]
        }
   }
}

   const [response,setResponse] = useState(initResState);

   const [bizBanking, setBizBanking] = useState({   //for Form 
        CompanyNametoAppear:'',
        NametoAppear:'',
        Suffix:''
   })
     
    useEffect(() => {
        
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        window.scrollTo(0,0);
        setCondOfSign(mandates[0]);   //default as Singly for Approval Mandate
        getData();

        return () => clearTimeout(timer);
    }, []);

    const getData = () => {
     
        service.get().then( res =>{
  
            if(res.data.isSucess){
                bindFormData(res.data.model.fields.request)
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
         
             setIsLoading(false);
        })
    }

    const subStrCompNametoAppear = (compNametoAppear) => {

        let str = '';
        if(compNametoAppear === undefined || compNametoAppear === null || compNametoAppear === '') {
            return str;
        }
        else {
            let tempStr = compNametoAppear.replace(/[^a-zA-Z0-9\-.,'/&/\s]/g, "");
           
            if(tempStr.length > 19) {
                str = tempStr.substring(0,19);
            }
            else {
                str = tempStr;
            }
        }
        return str;
    }

    const subStrNametoAppear = (nametoAppear) => {
      
        let str = '';
        if(nametoAppear === undefined || nametoAppear === null || nametoAppear === ''){
            return str;
        }
        else {
            let tempStr = nametoAppear.replace(/[^a-zA-Z0-9\-.\s]/g, "");
            
            if(tempStr.length > 19) {
                str = tempStr.substring(0,19);
            }
            else {
                str = tempStr;
            }
        }
         
        return str;
    }
 

    const bindFormData = (data) => {
        
        try {
     
            applicant = {value: data.ApplicantDtls.IDNum? data.ApplicantDtls.IDNum:'', label: data.ApplicantDtls.Name? data.ApplicantDtls.Name:''}
            setDCApplicanCbo(applicant);  
            setResponse(data);

            setIsLoading(false);
           
            if(data.MaybankBussinessPlatinumCard.CompanyNametoAppear === null){
             
                 //first time
                 setBizBanking({
                    CompanyNametoAppear:subStrCompNametoAppear(data.CompDtls.CompName),
                    NametoAppear:data.ApplicantDtls.Name? subStrNametoAppear(data.ApplicantDtls.Name):'',
                    Suffix:''
                });

                setBizNameOnCard(subStrCompNametoAppear(data.CompDtls.CompName));
                setNameOnCard(data.ApplicantDtls.Name? subStrNametoAppear(data.ApplicantDtls.Name):'');
                return;
            }
            else {
                bindBizBanking(data);
            }

        
       
        }catch(ex){
            setIsLoading(false);
        }
    }

    const bindBizBanking = (data) => {
     //bind the form data
        setBizBanking({
            CompanyNametoAppear:data.MaybankBussinessPlatinumCard.CompanyNametoAppear,
            NametoAppear:data.MaybankBussinessPlatinumCard.Applicant.NametoAppear,
            Suffix:data.BizInternetBank.ServiceLinkList.PaynowRegistration? data.BizInternetBank.ServiceLinkList.PaynowRegistration.Suffix? data.BizInternetBank.ServiceLinkList.PaynowRegistration.Suffix:'':''
        });

        setBizNameOnCard(data.MaybankBussinessPlatinumCard.CompanyNametoAppear);
        setNameOnCard(data.MaybankBussinessPlatinumCard.Applicant.NametoAppear);
   
        setSelectedApplyCheqBook(data.BizInternetBank.ApplyChequeBook? data.BizInternetBank.ApplyChequeBook!==null?data.BizInternetBank.ApplyChequeBook:'':'');
    }
    
     //Form Submit
     const handleSubmit = (eve) => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
      
        if(eve.isValid) {
         
            /*  //Mable: item 9
            if(selectedApplyCheqBook === '' || selectedApplyCheqBook === null || selectedApplyCheqBook === undefined) {
                showErrMsg(config.error.RdoOption);
                return;
            }
            */

            if(dcApplicanCbo.value === '') {
                showErrMsg('Oops!\nMissing Authorised User.');
                return;
            }
        
            let data = JSON.parse(JSON.stringify(eve.values));
            saveBizDetails(formatJsonParams(data));
        }
    }

    const saveBizDetails = (params) =>{
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(resData.errorMessage);
            }         
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.DelegationDetails);
        }
    }

    let formatJsonParams = function(data) {
        let params = {
            MaybankBussinessPlatinumCard:{
                CompanyNametoAppear: data.CompanyNametoAppear,
                Applicant:[{
                    NRIC: dcApplicanCbo.value,
                    Name: dcApplicanCbo.label,
                    NametoAppear:data.NametoAppear
                }]
            },
            BizInternetBank:{
                ApprovalMandate:mandates[0].value,  //default 1 Approval
                AcctLinkList:{
                    AcctLinkage:[
                        getValueInArray(response.BizAccts.PrefSGDAcct,sgdaccount),
                        response.BizAccts.PrefFrngAcct,
				        "Business Platinum Visa Debit Card"
                    ]
                },
                ServiceLinkList: {
                    ServiceLinkage: [
                        services[0].value,
                        services[1].value,
                        services[2].value,
                        services[3].value,
                        services[4].value,
                        services[5].value,
                        services[6].value,
                        services[7].value,
                        services[8].value,
                        services[9].value
                    ],
                    PaynowRegistration: {
                        Suffix: changeUppercase(data.Suffix)
                    }
                },
                UserRegistration:{
                    AuthUser:[
                        { NRIC: dcApplicanCbo.value, Name: dcApplicanCbo.label,Seq:'1'}
                    ]
                }
               // ApplyChequeBook:selectedApplyCheqBook   //Mable: item 9
            }
        }
        return params;
    }

    const changeUppercase = (text) => {
        if(text.length < 1){
            return '';
        }
        else {
            return text.toUpperCase();
        }
    }
    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
    
    const getLabelInArray = (iValue, array) => {
        const obj = array.find( ({ value }) => value === iValue);
        let result = '';
        if(obj){
            result = obj.label;
        }
 
        return result;
    }

    const getValueInArray = (iValue, array) => {
        const obj = array.find( ({ value }) => value === iValue);
        let result = '';
        if(obj){
            result = obj.value;
        }
 
        return result;
    }

    const handleShowBizReg = (e) =>{
        e.preventDefault();
        if(showBizReg){
            setShowBizReg(false);
        }
        else{
            setShowBizReg(true);
        }
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
               <SubHeader /><br/>
               <Form onSubmitClick={handleSubmit} 
                initialValues={bizBanking}
                key ={JSON.stringify(bizBanking)}
                render={(formRenderProps) => (
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} 
                                    id={bizBankingData.formContainerTitle.T1} 
                                    name={bizBankingData.formSubTitle.ST1} />
 
                                <Field component={FormSubTitleDesp} id={'fstSTD1'} 
                                    name={bizBankingData.note}  />

                                <div className="row around-xs inputPair elementVisible">
                                    <div className="cardImgCenter cardWidth">
                                        <div className="cardContainer">
                                            <img src={CardImg} alt="myimage" />
                                            <div className="cardBizLabel cardTxt">{nameOnCard}</div> 
                                            <div className="cardUserLabel cardTxt">{bizNameOnCard}</div>
                                        </div>
                                    </div>
                                </div>

                                <FieldWrapper>
                                    <Field component={CusFormInput} 
                                        leftLabelId={'lblcoName'} leftLabelName={bizBankingData.label.coNameOnCard} 
                                        placeholder={'Please input (19 characters in total)'}
                                        id={'CompanyNametoAppear'} name={'CompanyNametoAppear'}  
                                        maxLength={19} 
                                        validator={nameOnCardValidator}  
                                        onChange={(e) =>{
                                            setBizNameOnCard(e.value);
                                        }} />

                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box" style={{ marginTop: "5px" }}>
                                        {bizBankingData.label.dcApplicant1}</div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                    <ComboBox id="dcApplicantCbo" name="dcApplicanCbo"
                                        clearButton={false} data={bizBankingData.dcApplicant1data}
                                        textField="label" dataItemKey="value"
                                        disabled={true} value={dcApplicanCbo} />
                                    </div>
                                    </div>
                                </div>
                               <div style={{paddingBottom:'10px'}}>
                                    <Field component={CusFormInput} 
                                        leftLabelId={'lblnoncard'} leftLabelName={bizBankingData.label.nOnCard} 
                                        id={'NametoAppear'} name={'NametoAppear'} placeholder={'Please input'}
                                        maxLength={19}  
                                        validator={nametoAppearValidator} 
                                        onChange={(e)=>{
                                            setNameOnCard(e.value);
                                        }} />
                                </div>
                            </FieldWrapper>
                             
                            </fieldset>
                        </FormContainer>
                        <FormContainer>
                            <fieldset>
                             
                                <Field component={FormTitle} 
                                    id={bizBankingData.formContainerTitle.T2} 
                                    name={bizBankingData.formContainerTitle.T2.name} /> 
 
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div id={'fstST2'} style={{float:'left'}}>{bizBankingData.formSubTitle.ST2}</div>
                                    <div style={{float:'right'}} onClick={handleShowBizReg}>
                                        {showBizReg?
                                            <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Hide 
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-up" />
                                            </span> :
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Show  
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-down" />
                                        </span>}
                                    </div>
                                    </div>
                                </div>
                                </FieldWrapper>
                            
                                {showBizReg &&
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box" id={'lblapprovalM'} style={{ marginTop: "5px" }}>
                                        <div style={{width:'70%', float:"left"}}><span>{bizBankingData.label.approvalM}</span></div>
                                            <div style={{width:'30%', float:"left"}}>
                                            <Tooltip id={'ttapprovalM'} content={(props) => 
                                                    <TooltipTemplate id={'tttapprovalM'} title={props.title}/>} 
                                                        anchorElement={'target'} position={'right'} >
                                                        <span className="k-icon k-i-information" title={bizBankingData.tooltip.approvalMan}></span> 
                                            </Tooltip>
                                            </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                    <ComboBox
                                            id="condOfSignCbo" name="condOfSignCbo"
                                            clearButton={false}
                                            data={mandates}
                                            textField="label"
                                            dataItemKey="value"
                                            disabled={true}
                                            value={condOfSign}
                                        />
                                    </div>
                                </div>
                                </div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" id={'lblaccLinkage'}  style={{ marginTop: "5px" }}>
                                            <div style={{width:'70%', float:"left"}}><span>{bizBankingData.label.accLinkage}</span></div>
                                            <div style={{width:'30%', float:"left"}}>
                                            <Tooltip id={'ttAccLinkage'} content={(props) => 
                                                    <TooltipTemplate id={'tttAccLinkage'} title={props.title}/>} 
                                                        anchorElement={'target'} position={'right'} >
                                                        <span className="k-icon k-i-information" title={bizBankingData.tooltip.accLinkage}></span> 
                                            </Tooltip></div>
                                        </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                            <div className="box" style={{ marginTop: "5px", width:"100%" }}> 
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{getLabelInArray(response.BizAccts.PrefSGDAcct, sgdaccount)} </label> 
                                            </div>
                                            {response.BizAccts.PrefFrngAcct !== null && <div  className="box" style={{ width:"100%" }}> 
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{response.BizAccts.PrefFrngAcctDesc}</label> 
                                            </div>}
                                           
                                            <div  className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>Business Platinum Visa Debit Card</label> 
                                            </div>
                                        </div>
                                </div>

                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" id={'lblaccLinkage'}  style={{ marginTop: "5px" }}>
                                            <div style={{width:'70%', float:"left"}}><span>{bizBankingData.label.serLinkage}</span></div>
                                            <div style={{width:'30%', float:"left"}}>
                                            <Tooltip id={'ttserLinkage'} content={(props) => 
                                                    <TooltipTemplate id={'tttserLinkage'} title={props.title}/>} 
                                                        anchorElement={'target'} position={'right'} >
                                                        <span className="k-icon k-i-information" title={bizBankingData.tooltip.serLinkage}></span> 
                                            </Tooltip></div>
                                        </div>
                                    </div>
                                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                            <div className="box" style={{ marginTop: "5px", width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp; 
                                                <label>{services[0].label}</label> 
                                            </div>
                                            <div className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp; 
                                                <label>{services[1].label}</label> 
                                            </div>
                                            <div>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>Bulk Payment/Collection</label> 
                                                <label style={{paddingLeft:'10px'}}>(Inward/Outward GIRO) </label> 
                                            </div>
                                             
                                            <div  className="box" style={{ width:"100%" }}> 
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{services[3].label}</label> 
                                            </div>

                                            <div  className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{services[4].label}</label> 
                                            </div>

                                            <div  className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{services[5].label}</label> 
                                            </div>

                                            <div className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{services[6].label}</label> 
                                            </div>

                                            <div className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{services[7].label}</label> 
                                            </div>

                                            <div className="box" style={{width:"100%"}}>
                                                <span style={{float:"left",paddingRight:"10px"}}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label >{services[8].label}</label>  </span>
                                           
                                                <Tooltip content={(props) => 
                                                    <TooltipTemplate title={props.title}/>} 
                                                        anchorElement={'target'} position={'right'} >
                                                        <span className="k-icon k-i-information" title={bizBankingData.tooltip.paynow}></span> 
                                                </Tooltip>
                                            </div>
                                            <div className="box row" style={{ width:"100%" }}>
                                                <div style={{float:'left', width:'50%', paddingLeft:"20px"}}>
                                                    <Input name={'UEN'} placeholder={'UEN'} disabled={true} value={response.CompDtls.RegNo}/> 
                                                </div>
                                                <div style={{float:'left', width:'50%', paddingLeft:'5px'}}>
                                                    <Field component={FormUpperCaseInput} placeholder={'Suffix(Optional)'} id={'Suffix'} name={'Suffix'} maxLength={3} validator={suffixValidator} />
                                                </div>
                                            </div>
                                            <div className="box" style={{ width:"100%", paddingTop:'10px'}}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{services[9].label}</label> 
                                            </div>
                                        </div>
                                </div>
 
                                <div> <hr className="greyPanelLine" /> </div>
                                </FieldWrapper> }

                                <Field component={FormSubTitleTooltip} 
                                     id={'fstST3'} name={bizBankingData.formSubTitle.ST3}
                                    tooltipPosition={'right'} tooltipAchor={'target'} 
                                    tooltipTitle={bizBankingData.tooltip.ST3}/>
 
                                <FieldWrapper>
                                    <Field component={CusFormLabel} 
                                        leftLabelId={'lblAuthUser'} leftLabelName={bizBankingData.label.authUser} 
                                        id={'authUser'} name={dcApplicanCbo.label} />  
                                </FieldWrapper>

                                {/* <FieldWrapper>   //Mable: item 9
                                    <CusRadioButton name={'ApplyCheqBook'} leftValue='Y' rightValue='N'
                                        disabled={false} label={bizBankingData.label.applyCheqBook}
                                        checkedValue={selectedApplyCheqBook}  
                                        onChange={ e => {
                                            setSelectedApplyCheqBook(e.value);
                                        }} /> 
                                </FieldWrapper> */}
                               
                        <FieldWrapper>
                        <CusProgressBar  bgcolor={item.bgcolor} completed={item.completed} /> 

                        <div className="row around-xs inputPair elementVisible">
                            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                                <button className="btn btn-back" onClick={() => { history.push(config.route.ApplicantDetails)}}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                            </div>
                        </div> 
                        </FieldWrapper>

                        {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                                onClose={()=>{ setIsError(false)}} />} */}
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 

                        </fieldset>
                        </FormContainer>
                    </FormElement>
                )}>
             
               </Form>
               {isSaving && <Loading />}  
        </div>
    )

}

export default BizBankingService